import React, { Component } from 'react'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
import _get from 'lodash/get'
// import _find from 'lodash/find'
import _findLast from 'lodash/findLast'
import moment from 'moment'
import { Marker } from 'react-google-maps'

import config from '~/config'

const parameters = _get(config, 'app.parameters', [])
const SALINITY = parameters.find(p => p.name === 'ความเค็ม')
class POI extends Component {
  render () {
    const { data, poi, view, onClick, salinityRecords } = this.props
    const { daysOffset } = view
    const today = moment(data.now).clone().set({ hour: 0, minute: 0, second: 0 })
    let color
    const currentDay = today.clone().add(daysOffset, 'day')
    const salinity = _findLast(salinityRecords, rec => currentDay.isSame(moment(rec.observedTimestamp), 'day'))
    if (salinity) {
      SALINITY.scales.forEach(([value, c]) => {
        if (salinity.value > value) {
          color = c
        }
      })
    }
    return <Marker
      icon={{
        //        path: 'M24-28.3c-.2-13.3-7.9-18.5-8.3-18.7l-1.2-.8-1.2.8c-2 1.4-4.1 2-6.1 2-3.4 0-5.8-1.9-5.9-1.9l-1.3-1.1-1.3 1.1c-.1.1-2.5 1.9-5.9 1.9-2.1 0-4.1-.7-6.1-2l-1.2-.8-1.2.8c-.8.6-8 5.9-8.2 18.7-.2 1.1 2.9 22.2 23.9 28.3 22.9-6.7 24.1-26.9 24-28.3z',
        path: 'M22-48h-44v43h16l6 5 6-5h16z',
        fillColor: color,
        fillOpacity: 0.7,
        // strokeColor: 'black'
        strokeWeight: 0
      }}
      // icon={main ? { url: '/public/main_marker.png' } : null }

      position={{ lat: poi.latitude, lng: poi.longitude }}
      label={poi.poiName}
      title={poi.poiName}
      onClick={onClick}
    >
    </Marker>
  }
}

export default compose(
  inject('data'),
  inject('view'),
  observer
)(POI)



// WEBPACK FOOTER //
// ./src/modules/Forecasting/POI.js